/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { pipe } from 'ramda';
import { connect } from 'react-redux';
import { selectModelIsUnderMaintenance } from '#selectors/entities/models.js';
import getComponent from './withMaintenanceMode.jsx';

const getContainer = C => {
  const mapStateToProps = (state, ownProps) => {
    const isUnderMaintenance = selectModelIsUnderMaintenance(state, ownProps);
    return {
      isUnderMaintenance,
      ...ownProps,
    };
  };
  return connect(mapStateToProps)(C);
};

export default pipe(getComponent, getContainer);
